import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCommentNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M3 5.75h10V7H3zM3 8v1.25h7V8z" />
        <path d="M0 3.958C0 2.877.877 2 1.958 2h12.084C15.123 2 16 2.877 16 3.958v7.084A1.958 1.958 0 0114.042 13H7.759l-2.636 2.636A1.243 1.243 0 013 14.756V13H1.958A1.958 1.958 0 010 11.042zm1.958-.708a.708.708 0 00-.708.708v7.084c0 .39.317.708.708.708H4.25v2.991l2.991-2.991h6.8a.708.708 0 00.709-.708V3.958a.708.708 0 00-.708-.708z" />
      </g>
    </svg>
  )
);
SvgActionsCommentNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCommentNormalXsmall;
